<template>
    <full-card class="mb-8">

        <template v-slot:header>Avatar (Beta)</template>

        <p class="text-sm text-gray-500">
            Avatare werden auf der Karte angezeigt,
            wenn die Einstellungen <span class="font-bold">Zeige Freunde/Kollegen auf der Karte an</span>
            aktiviert ist.
        </p>

        <loading v-show="loading"></loading>

        <div v-show="!loading">

            <div class="mb-2">
                Avatar:
                <input type="file" ref="avatar" @change="handleAvatarUpload" class="border" accept=".png,.jpg,.jpeg">
              <p class="mt-2 text-sm text-gray-500">
                <i class="fa fa-info mr-2"/>Avatar muss als <span class="font-bold">png</span> oder <span
                  class="font-bold">jpg</span> hochgeladen werden. Max. <span class="font-bold"> 1 MB </span>
              </p>
              <p class="mt-2 ml-2 text-sm text-red-500 font-bold">
                {{ error }}
              </p>
            </div>

            <div v-show="!value.avatar">
                Kein Avatar hinterlegt.
            </div>

            <div class="mb-4 flex" v-show="value.avatar">
                <img :src="value.avatar" class="h-25 border" alt="Avatar">
                <confirm-dialog @confirmed="removeMap">
                    <i class="fa fa-times"></i>
                    <template v-slot:header>Karte löschen</template>
                    <template v-slot:question>Soll der Avatar wirklich entfernt werden?</template>
                    <template v-slot:confirm>
                        <button-delete>
                            <template slot="icon"><i class="fa fa-trash"></i></template>
                            Löschen
                        </button-delete>
                    </template>
                </confirm-dialog>
            </div>

        </div>
    </full-card>
</template>

<script>
import FullCard from "../UI/FullCard.vue";
import ConfirmDialog from "../UI/ConfirmDialog.vue";
import ButtonDelete from "../UI/ButtonDelete.vue";
import Loading from "../UI/Loading.vue";

export default {
    name: "UserAvatar",

    components: {
        Loading,
        ButtonDelete,
        ConfirmDialog,
        FullCard,
    },

    props: ['value'],

    data: () => ({
        loading: false,
        error: null
    }),

    methods: {
        handleAvatarUpload() {
            this.loading = true;
            this.error = null;
            let avatar = this.$refs.avatar.files[0];
            if (avatar.size > 1024 * 1024 * 1) {
              this.error = "Die Datei ist zu groß! Bitte max. 1 MB hochladen."
              this.loading = false;
              return;
            }
            if (avatar.type != "image/jpeg" && avatar.type != "image/png") {
              this.error = "Bitte nur png oder jpeg hochladen."
              this.loading = false;
              return;
            }
            let formData = new FormData();
            formData.append('avatar', avatar);
            formData.append('_method', 'put');
            this.$http
                .post(`/admin/users/${this.value.id}`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(() => {
                    this.$emit('updated');
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        },
        removeMap() {
            this.loading = true;
            this.$http.post(`/admin/users/${this.value.id}`, {
                _method: 'put',
                avatar: '',
            }).then(() => {
                this.$emit('updated');
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    }
}
</script>

<style scoped>

</style>
